import cuid from "@paralleldrive/cuid2"

// https://github.com/ericelliott/cuid/issues/88
// cuid.isCuid does not check for string length
export function isCuid(input: unknown) {
  if (typeof input !== "string") {
    return false
  }

  return cuid.isCuid(input) && input.length === 25
}

// A wrapper for "JSON.parse()"" to support "undefined" value
export function safeJsonParse<T>(value: string | null | undefined): T | undefined {
  try {
    return value === "undefined" ? undefined : JSON.parse(value ?? "")
  } catch {
    return undefined
  }
}
